"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEcommSetUp = exports.getOwnerProperties = exports.getProductProperties = exports.getContactProperties = exports.getCompanyProperties = exports.getFetchProductPropertiesRequestStatus = exports.getFetchContactPropertiesRequestStatus = exports.getFetchCompanyPropertiesRequestStatus = exports.getProperties = void 0;

var _reselect = require("reselect");

var _constants = require("./constants");

var _getRequestStatus = _interopRequireDefault(require("../RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var _ProductProperties = require("customer-data-objects/product/ProductProperties");

var getProperties = function getProperties(state) {
  return state.properties;
};

exports.getProperties = getProperties;
var getFetchCompanyPropertiesRequestStatus = (0, _getRequestStatus.default)(_actions.PropertyActionTypes.FETCH_COMPANY_PROPERTIES);
exports.getFetchCompanyPropertiesRequestStatus = getFetchCompanyPropertiesRequestStatus;
var getFetchContactPropertiesRequestStatus = (0, _getRequestStatus.default)(_actions.PropertyActionTypes.FETCH_CONTACT_PROPERTIES);
exports.getFetchContactPropertiesRequestStatus = getFetchContactPropertiesRequestStatus;
var getFetchProductPropertiesRequestStatus = (0, _getRequestStatus.default)(_actions.PropertyActionTypes.FETCH_PRODUCT_PROPERTIES);
exports.getFetchProductPropertiesRequestStatus = getFetchProductPropertiesRequestStatus;
var getCompanyProperties = (0, _reselect.createSelector)([getProperties], function (properties) {
  return properties.get(_constants.COMPANIES);
});
exports.getCompanyProperties = getCompanyProperties;
var getContactProperties = (0, _reselect.createSelector)([getProperties], function (properties) {
  return properties.get(_constants.CONTACTS);
});
exports.getContactProperties = getContactProperties;
var getProductProperties = (0, _reselect.createSelector)([getProperties], function (properties) {
  return properties.get(_constants.PRODUCTS);
});
exports.getProductProperties = getProductProperties;
var getOwnerProperties = (0, _reselect.createSelector)([getProperties], function (properties) {
  return properties.get(_constants.OWNERS);
});
exports.getOwnerProperties = getOwnerProperties;
var isEcommSetUp = (0, _reselect.createSelector)([getProductProperties], function (productProperties) {
  return Boolean(productProperties.get(_ProductProperties.ECOMM_SYNCED));
});
exports.isEcommSetUp = isEcommSetUp;